import { ReactComponent as IcxeedLogo } from "../images/icxeed-logo-cx.svg";
import { ReactComponent as SettingsIcon } from "../images/settings.svg";

const Navigation = () => {
  return (
    <div className="main-navigation">
      <div className="cx-perspectives-nav-blk">
        <div className="flex-blk">
          <div className="flex-navigation">
            <IcxeedLogo />
            <h2>CX Perspectives</h2>
          </div>
          <div>
            <SettingsIcon width={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
